import React from "react";
import PriceCard from "./PriceCard";
import "./style.css";

const Prices = () => {
  const prices = [
    {
      src: "gym_pr_1.png",
      alt: "gym_pr_1",
      price: "1100k idr",
      note: "4 classes",
    },
    {
      src: "gym_pr_2.png",
      alt: "gym_pr_2",
      price: "2000k idr",
      note: "8 classes",
    },
    {
      src: "gym_pr_3.png",
      alt: "gym_pr_3",
      price: "3000k idr",
      note: "12 classes",
    }
  ];

  return (
    <div className="pricesContainer" id="prices">
      <h2>PRICES</h2>
      <div className="priceContainer">
        {prices.map(({ src, alt, price, note }, index) => (
          <PriceCard
            key={`${index}`}
            src={src}
            alt={alt}
            price={price}
            note={note}
          />
        ))}
      </div>
    </div>
  );
};

export default Prices;
